// src/deeplink.js
// Universal deep-link parser for Geilstore Community.
// Supports:  /event/12   /post/34   /?event=12   /?post=34
// Survives the login redirect via sessionStorage.

const KEY = "gc_deeplink";

// Whitelist. type -> App.js page state. Anything not here is ignored.
const TYPES = { event: "events", post: "post_detail" };

// IDs are digits only, max 12 chars. Blocks ?event=<script> and ?event=../../
const isId = (v) => typeof v === "string" && /^[0-9]{1,12}$/.test(v);

export function parseDeepLink() {
  try {
    const path = window.location.pathname || "";
    const m = path.match(/^\/(event|post)\/([0-9]{1,12})\/?$/);
    if (m) return { type: m[1], id: m[2] };

    const qs = new URLSearchParams(window.location.search || "");
    for (const t of Object.keys(TYPES)) {
      const v = qs.get(t);
      if (isId(v)) return { type: t, id: v };
    }
  } catch { /* ignore */ }
  return null;
}

// Run ONCE on boot. Stashes the target. URL is left intact so refresh works.
export function captureDeepLink() {
  const dl = parseDeepLink();
  if (!dl) return null;
  try { sessionStorage.setItem(KEY, JSON.stringify(dl)); } catch { /* ignore */ }
  return dl;
}

// Reset the address bar once the user navigates somewhere else.
export function clearDeepLinkUrl() {
  try {
    if (window.location.pathname !== "/" || window.location.search) {
      window.history.replaceState({}, "", "/");
    }
  } catch { /* ignore */ }
}

export function peekDeepLink() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const dl = JSON.parse(raw);
    return (dl && TYPES[dl.type] && isId(String(dl.id))) ? dl : null;
  } catch { return null; }
}

// Read + clear. Call this when the target page has actually opened it.
export function consumeDeepLink() {
  const dl = peekDeepLink();
  try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
  return dl;
}

export function pageForDeepLink(dl) {
  return dl && TYPES[dl.type] ? TYPES[dl.type] : null;
}

export const buildEventUrl = (id) => `https://community.geilstore.com/event/${id}`;
export const buildPostUrl  = (id) => `https://community.geilstore.com/post/${id}`;